
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/dev/[id]",
      function () {
        return require("private-next-pages/blog/dev/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/dev/[id]"])
      });
    }
  